import React from "react";
import "./about.css";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";
import me from "../../asset/profile3.jpg";
function about() {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-image">
            <img src={me} alt="About_Image" />
          </div>
        </div>
        <div className="about_content">
          <div className="about_cards">
            <article className="about_card">
              <FaAward className="about_icon" />
              <h5> Experience </h5>
              <small> 1 Year Experience </small>
            </article>

            <article className="about_card">
              <FiUsers className="about_icon" />
              <h5> Clients </h5>
              <small> 0 </small>
            </article>

            <article className="about_card">
              <a href="#portfolio">
                <VscFolderLibrary className="about_icon" />
                <h5> Projects </h5>
                <small> 6 Completed </small>
              </a>
            </article>
          </div>
          <p>
            As a seasoned MERN stack developer, I possess advanced expertise in
            MongoDB, Express.js, React, and Node.js. My specialization lies in
            crafting dynamic web applications that are not only responsive but
            also user-friendly. My extensive knowledge and experience enable me
            to contribute significantly to any develop- ment project. I am
            deeply passionate about creating scalable and efficient web
            solutions that are tailored to the unique needs of my clients.
          </p>
        </div>
        <a href="#contact" className="btn btn-primary">
          Let's Talk
        </a>
      </div>
    </section>
  );
}

export default about;
